import type { FhhState } from '../fhhDefaultState';

export const buildFhhTrackingItem = (state: FhhState) => ({
    id: 'finntravel',
    type: 'Travel',
    destination: state.destination,
    travelType: 'holiday_rental',
    numberOfRooms: state.numOfBedrooms,
    numberOfBeds: state.numOfBeds,
});
